export const setUserLocale = (locale) =>{
    return{
        type:'SET_LOCALE',
        value:locale
    }
};

export const setUserLanguageLocale = (langCode) =>{
    return{
        type:'SET_LOCALE_LANGUAGE',
        value:langCode
    }
};

export const setAvailableLocale = (locales) =>{
    return{
        type:'SET_AVAILABLE_LOCALE',
        value:locales
    }
};

export const setGlobalNavLocale = (locale) =>{
    return{
        type:'SET_NAV_LOCALE',
        value:locale
    }
};

